"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuery = void 0;

var _client = require("@apollo/client");

var _react = require("react");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useQuery = (query, options) => {
  var {
    data,
    previousData: previous,
    loading,
    networkStatus,
    error,
    refetch,
    fetchMore,
    client
  } = (0, _client.useQuery)(query, _objectSpread({
    notifyOnNetworkStatusChange: true
  }, options));
  var {
    isLoading,
    refetching
  } = (0, _react.useMemo)(() => {
    return {
      isLoading: loading,
      refetching: networkStatus === _client.NetworkStatus.refetch
    };
  }, [loading, networkStatus]);
  return {
    data,
    previous,
    loading: isLoading,
    refetch,
    refetching,
    fetchMore,
    error,
    client
  };
};

exports.useQuery = useQuery;